var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobOpening(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.323,
    height: 179.707,
    viewBox: "0 0 170.323 179.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2374",
    "data-name": "Group 2374",
    transform: "translate(-342 -1093.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2370",
    "data-name": "Group 2370",
    transform: "translate(342 1093.292)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    cx: 78.5,
    cy: 78.5,
    r: 78.5,
    transform: "translate(0 14.707)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_593",
    "data-name": "Rectangle 593",
    width: 115,
    height: 52,
    rx: 8,
    transform: "translate(21 34.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_594",
    "data-name": "Rectangle 594",
    width: 115,
    height: 86,
    rx: 8,
    transform: "translate(21 93.707)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    width: 39,
    height: 6,
    rx: 3,
    transform: "translate(33 45.707)",
    fill: "#195cff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 74,
    height: 5,
    rx: 2.5,
    transform: "translate(33 59.707)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    width: 28,
    height: 5,
    rx: 2.5,
    transform: "translate(33 70.707)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2722",
    "data-name": "Path 2722",
    d: "M2.657,0H36.306a2.657,2.657,0,0,1,0,5.313H2.657A2.657,2.657,0,0,1,2.657,0Z",
    transform: "translate(32.587 105.804)",
    fill: "#195cff",
    opacity: 0.457
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_599",
    "data-name": "Rectangle 599",
    width: 74,
    height: 5,
    rx: 2.5,
    transform: "translate(33 119.707)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_600",
    "data-name": "Rectangle 600",
    width: 28,
    height: 5,
    rx: 2.5,
    transform: "translate(33 130.707)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    width: 29.045,
    height: 3.896,
    rx: 1.948,
    transform: "translate(137.474 29.686) rotate(-45)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_602",
    "data-name": "Rectangle 602",
    width: 17.002,
    height: 3.896,
    rx: 1.948,
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 152.892, 43.23)",
    fill: "#dce5f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 18.064,
    height: 3.896,
    rx: 1.948,
    transform: "matrix(0.259, -0.966, 0.966, 0.259, 120.714, 17.449)",
    fill: "#dce5f4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobOpening);
export default __webpack_public_path__ + "static/media/job-opening.b1bbe29e9bb6cedfb4ec2fd4cd49f8c0.svg";
export { ForwardRef as ReactComponent };